/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
"use strict";
exports.DEFAULT_ALARM_SETTINGS = {
    "defaultMsgColore": "white",
    "pendingAlarmMsgClassFilter": [1, 3],
    "pendingAlarmStateFilter": [0, 1, 3],
    "messageClasses": [
        {
            "name": "S7-Meldung",
            "id": 1,
            "display": "CPU:",
            "ack": 0,
            "colors": {
                "0": "red",
                "1": "red",
                "2": "red",
                "3": "red",
                "4": "white",
                "6": "white"
            }
        },
        {
            "name": "S7-Warnung",
            "id": 3,
            "display": "CPU:",
            "ack": 0,
            "colors": {
                "0": "white",
                "1": "white",
                "2": "white",
                "3": "white",
                "4": "white",
                "6": "white"
            }
        },
        {
            "name": "S7",
            "id": 10,
            "display": "",
            "ack": 0,
            "colors": {
                "0": "gray",
                "1": "gray",
                "2": "white",
                "3": "white",
                "4": "white",
                "6": "white"
            }
        }
    ]
};
